// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Navbar-component (staat in src/pages/navbar.js)
import Navbar from './pages/navbar';

// Publieke pagina's
import Home from './pages/home';                               // src/pages/home.js
import HSBakBord from './pages/hsbakbord/hsbakbord';           // src/pages/hsbakbord/hsbakbord.js
import HSBakRad from './pages/hsbakrad/hsbakrad';              // src/pages/hsbakrad/hsbakrad.js
import HSBakMeter from './pages/hsbakmeter/hsbakmeter';     // src/pages/hsbakmeter/hsbakmeter.js
import Login from './pages/login';                             // src/pages/login.js

// Auth-gerelateerde pagina's (in src/pages/Auth/)
import Inloggen from './pages/Auth/inloggen';                  // src/pages/Auth/inloggen.js
import Aanmelden from './pages/Auth/Aanmelden';                // src/pages/Auth/Aanmelden.js
import Account from './pages/Auth/account';                    // src/pages/Auth/account.js

// Admin pages
import AdminPage from './pages/Admin/AdminPage';               // src/pages/Admin/AdminPage.js
import AdminSetup from './pages/Admin/AdminSetup';             // src/pages/Admin/AdminSetup.js
import AdminBasic from './pages/Admin/AdminBasic';             // src/pages/Admin/AdminBasic.js
import AdminUsers from './pages/Admin/AdminUsers';             // src/pages/Admin/AdminUsers.js
import AdminWithTemplates from './pages/Admin/AdminWithTemplates'; // src/pages/Admin/AdminWithTemplates.js

// Context providers
import { AdminProvider } from './contexts/AdminContext';        // Admin role context

// PrivateRoute (staat in src/PrivateRoute.js)
import PrivateRoute from './PrivateRoute';

// Google Analytics
import './firebase';

import './App.css';

function App() {
  return (
    <div className="App">
      <AdminProvider>
        <Router>
          <Navbar />

          <Routes>
            {/* Publieke routes */}
            <Route path="/" element={<Home />} />
            <Route path="/hsbakbord" element={<HSBakBord />} />
            <Route path="/hsbakrad" element={<HSBakRad />} />
            <Route path="/hsbakmeter" element={<HSBakMeter />} />
            <Route path="/login" element={<Login />} />
            <Route path="/inloggen" element={<Inloggen />} />
            <Route path="/Aanmelden" element={<Aanmelden />} />

            {/*  Beschermde route: alleen ingelogde gebruikers zien Account */}
            <Route
              path="/account"
              element={
                <PrivateRoute>
                  <Account />
                </PrivateRoute>
              }
            />
            
            {/* Admin routes */}
            <Route
              path="/admin"
              element={
                <PrivateRoute>
                  <AdminPage />
                </PrivateRoute>
              }
            />
            <Route
              path="/admin-setup"
              element={
                <PrivateRoute>
                  <AdminSetup />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </AdminProvider>
    </div>
  );
}

export default App;
